import { render, staticRenderFns } from "./SaleProgramUpdate.vue?vue&type=template&id=06d01f7b&"
import script from "./SaleProgramUpdate.vue?vue&type=script&lang=js&"
export * from "./SaleProgramUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports